<template>
    <div>
        <v-card>
            <v-toolbar dark color="secomdary">
                <v-spacer></v-spacer>
                <v-toolbar-title>New GP Item List</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <!-- <v-layout row>
                    <v-flex xs12 body-2 pt-1>
                        <v-select
                        v-model="docCategoryIdSelected"
                        :items="docCategories"
                        item-text="name"
                        item-value="id"
                        box
                        label="Class To Search"
                        ></v-select>
 
                    </v-flex>
                    <v-flex xs12 text-xs-center pt-1>
                        <v-btn @click="onGetNotMappedGpItems" large color="primary">Search</v-btn>
                    </v-flex>
                </v-layout> -->
                <!-- <v-layout>
                    <v-flex xs12 body-2 pt-1>Result:</v-flex>

                </v-layout> -->
                <v-data-table
                    :headers="headers"
                    :items="itmNewGpItems"
                    hide-actions
                    >
                    <template slot="items" slot-scope="props">
                      <td class="px-1 text-xs-center text-no-wrap">{{ props.item.classId }}</td>
                      <td class="px-1">{{ props.item.number }}</td>
                      <td class="px-1 text-no-wrap">{{ props.item.desc }}</td>
                      <td class="px-1 text-xs-center">{{ props.item.gpCreateDate }}</td>

                        <td>
                            <v-btn small color="primary" @click="onMappingItem(props.item, 'active')" >Add To Catalog</v-btn>
                            <v-btn small color="warning" @click="onMappingItem(props.item, 'discontinued')" >Set to Discountinued</v-btn>
                            <v-btn small color="warning" @click="onMappingItem(props.item, 'notSold')" >Set to NotSold</v-btn>
                            <v-btn small color="warning" @click="onMappingItem(props.item, 'hidden')" >Set to Hidden</v-btn>
                            <!-- <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn> -->
                        </td>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>
        <!-- <v-dialog v-model="showItmDocEditPopup" width="600" height="500">
            <ctlItmDocEdit 
                :itemDoc="itmDocToEdit"
                @onCloseItmDocEdit="onCloseItmDocEdit"
                ></ctlItmDocEdit>
        </v-dialog> -->

    </div>
</template>
<script>
// import ctlItmDocEdit from '@/components/productDb/ctlItmDocEdit.vue'
import { mapActions } from 'vuex'
export default {
    // props: ['itemDocs'],
    components: {
        // ctlItmDocEdit,
    },
    data() {
        return {
            // docCategories: [
            //     {id: 'brochure', name: 'Brochure'},
            //     {id: 'priceList', name: 'Price List'},
            //     {id: 'ifu', name: 'IFU'},
            //     {id: 'memo', name: 'Memo'},
            //     {id: 'sds', name: 'SDS'},
            // ],
            // docCategoryIdSelected: 'brochure',
            itmNewGpItems: [],
            headers: [
                { text: 'Class' , sortable: false},
                { text: 'Number', sortable: false},
                { text: 'Desc.' , sortable: false},
                { text: 'Create', sortable: false, class: ['px-1']},
                { text: '', sortable: false}
            ],
            // itmDocToEdit: null,
            // showItmDocEditPopup: false,
        }
    },
    methods: {
        ...mapActions('adminItemProdDb', [
            'getNotMappedGpItems',
            'mapGpItemToItmProdDbItem',
        ]),
        async onGetNotMappedGpItems() {
            this.itmNewGpItems = await this.getNotMappedGpItems({})
        },
        // onCreateNewDoc() {
        //     this.itmDocToEdit = {
        //         // id = doc.Id,
        //         // docCategoryId = doc.ItmDocCategory.Id,
        //         // docName = doc.DocName,
        //         // docUrl = doc.DocUrl,
        //         status: 'active',
        //         // notes = doc.Notes,

        //     }
        //     this.showItmDocEditPopup = true
        // },
        async onMappingItem(itmDoc, status) {
            // this.itmDocToEdit = itmDoc
            // this.showItmDocEditPopup = true
            var newProdItem = {
                itmItemId: itmDoc.id,
                itmProdDbItemStatus: status
            }
            await this.mapGpItemToItmProdDbItem(newProdItem)
            await this.onGetNotMappedGpItems()
        },
        // onCloseItmDocEdit() {
        //     this.itmDocToEdit = null
        //     this.showItmDocEditPopup = false
        //     this.onGetNotMappedGpItems()
        // }
    },
    created() {
        this.onGetNotMappedGpItems()
    }
}
</script>